import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './components/app/App';
import Footer from './pages/footer';
import Header from './pages/header';

import { Provider } from 'react-redux';
import { store, persistor } from '../src/components/store/store';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <persistGate loadding={null} persistor={persistor} >
      <React.StrictMode>
        <Header />
        <App />
        <Footer />
      </React.StrictMode>
    </persistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
